export default "__VITE_ASSET__MzgbeTJ3__"